'use client';

import { useLocale } from '@/app/_contexts/locale-context';
import { HubspotForm } from '@custom/form-embed-form-handler/hubspot-form';

const FORM_IDS: Record<string, string> = {
  de: 'ce128189-8b62-436c-b892-7b504784ad02',
  en: '38e3b850-78ab-4ccd-9746-1004bbdcaa60',
};

/**
 * Footer Additional Content Top
 *
 * This component is project-specific and will be loaded dynamically
 * in the shared footer. Contains the HubSpot newsletter form.
 */
export function FooterAdditionalContentTop() {
  const locale = useLocale();
  const formId = FORM_IDS[locale] || FORM_IDS.de;

  return (
    <div className="relative z-0 mx-auto w-full max-w-md lg:-mr-10 lg:max-w-lg lg:min-w-lg lg:justify-self-end">
      <HubspotForm
        portalId="147548584"
        formId={formId}
        region="eu1"
      />
    </div>
  );
}
